import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsBasicStep.AddPersonPopup', {
    addPerson: 'Add User',
    stepOf: 'Step {index} of {total}',
});
